export var FeedPressureType;
(function (FeedPressureType) {
    FeedPressureType["EJECTOR"] = "ejector";
    FeedPressureType["BLOW_OFF"] = "blow_off";
})(FeedPressureType || (FeedPressureType = {}));
export var SystemModel;
(function (SystemModel) {
    SystemModel["CENTRALIZED"] = "centralized";
    SystemModel["DECENTRALIZED"] = "decentralized";
    SystemModel["MULTI_CIRCUIT"] = "multi_circuit";
})(SystemModel || (SystemModel = {}));
/* The object type of the handled object that cups outside of the part sit on */
export var noMaterialObjectType = "NOMATERIAL";
/* How the calculated sense valve/restrictor behaviour rates, worst first */
export var flowRestrictionFindingSeverities = [
    "critical",
    "warning",
    "info",
    "ok",
];
